import {Injectable, Inject} from '@angular/core';
import {HttpClient, HttpHeaders, HttpResponse} from "@angular/common/http";
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {HttpOptions} from '../../modele/authModel';
import {SpotifyChannel} from "../../modele/social-media/spotifyModels";
import {BackendService} from "../api/backend.service";
import {SpotifyAuthorization} from "../../modele/backendResponses";
import {NGXLogger} from "ngx-logger";

export const BING_API_KEY = '6fb7aaa7796f4baeb78c83b72dd632e7';
export const BING_API_URL = 'https://api.bing.microsoft.com/v7.0/news/search?q=';

@Injectable({
    providedIn: 'root'
})
export class BingService {

    log_prefix = this.constructor.name + ":";
    private auth_url: string;
    private local_auth:SpotifyAuthorization;

    constructor(private http: HttpClient, private bes: BackendService,private logger:NGXLogger,
                @Inject(BING_API_KEY) private apiKey: string,
                @Inject(BING_API_URL) private apiUrl: string,) {

    }

    getBingNews(query: string): Observable <any[] > {

        let lp=this.log_prefix+"getBingFeed:";
        const headers = new HttpHeaders({'Ocp-Apim-Subscription-Key': this.apiKey});
        let options = new HttpOptions();
        options.setHttpHeaders(headers);
        const params = `${query}`;
        const queryUrl = `${this.apiUrl}${params}`;

        return new Observable<any>((observer) => {

            this.http.get(queryUrl, options).subscribe((response: HttpResponse<any>) => {
                let items = response['items'];

                observer.next(response);
            });
        });
    }
}
